// extracted by mini-css-extract-plugin
module.exports = {"DocumentDiv":"ProtocolPreview_DocumentDiv__2kMYY","Document":"ProtocolPreview_Document__2F3fO"};